<div class="clipboard-copy">
  <ng-container *ngIf="(isCopied$ | async) === false; else copied">
    <studio-icon data-test="copy" name="copy" (click)="copyValue()"></studio-icon>
  </ng-container>
  <ng-template #copied>
    <studio-icon data-test="check" name="check"></studio-icon>
  </ng-template>
</div>
